import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../index";
import { sleep } from "../../../../common/utils";
import { moveDeviceListInSpace } from "../../../../api/space/space";

type moveSpaceDeviceListState = {
  loading: boolean;
  error?: string | Error;
  success: boolean;
};

const initialState: moveSpaceDeviceListState = {
  loading: false,
  success: false,
};

export const fetchMoveDeviceListInSpace = createAsyncThunk(
  "space/deviceSetting/move",
  async ({ id, deviceList }: { id: number; deviceList: number[] }) => {
    await sleep(100);
    const { result } = await moveDeviceListInSpace(id, { deviceList });
    return result;
  }
);

const slice = createSlice({
  name: "space/deviceSetting/move",
  initialState,
  reducers: {
    resetMoveSpaceDeviceList: (state: moveSpaceDeviceListState) => ({
      ...state,
      loading: initialState.loading,
      success: initialState.success,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMoveDeviceListInSpace.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchMoveDeviceListInSpace.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.error = undefined;
        state.success = payload;
      }
    );
    builder.addCase(fetchMoveDeviceListInSpace.rejected, (state, { error }) => {
      state.loading = false;
      state.error = error.message as string;
      state.success = false;
    });
  },
});

export const moveSpaceDeviceListSelector = (state: RootState) =>
  state.space.deviceSetting.move;
export const { resetMoveSpaceDeviceList } = slice.actions;

export default slice;
